import { Stack } from '@mui/material';
import { useForm } from 'react-hook-form';
import * as Yup from 'yup';
import { MobileTitle } from '../../../../components/style/TextStyle';
import { useAuthAxios } from '../../../../hooks/useAuthAxios';
import { useYupValidationResolver } from '../../../../hooks/useYupValidationResolver';
import {
  OUTDOOR_GYM_EQUIPMENT_ID,
  responsiveMargin,
} from '../../../../utils/enum';
import { CreateSportingForm } from '../Common/CreateCategoryForm';
import {
  sportingDefaultValue,
  sportingSchema,
} from '../Common/DefaultValuesAndSchema';
import AddMobileCategoryButton from './AddMobileCategoryButton';
import { GoBackIconButton } from './GoBackIconButton';

export default function SportingCategoryMobile() {
  const resolver = useYupValidationResolver(
    Yup.object().shape({
      ...sportingSchema,
    }),
  );

  const form = useForm<any>({
    mode: 'onTouched',
    resolver,
    defaultValues: {
      ...sportingDefaultValue,
    },
    shouldUnregister: false,
  });
  const [postSportingResult, postSporting] = useAuthAxios({
    method: 'POST',
    url: '/api/v1/subcategory',
  });

  const onSubmit = form.handleSubmit(function (values) {
    const payload = {
      title: values.title,
      subCategoryType: values.subCategoryType,
      notes: values.notes,
      categoryId: OUTDOOR_GYM_EQUIPMENT_ID,
    };
    postSporting({ data: payload });
  });

  return (
    <Stack mx={responsiveMargin} spacing={5} my={{ xs: 2, md: 10 }}>
      <Stack direction="row" justifyContent="space-between" alignItems="center">
        <GoBackIconButton form={form} />
        <MobileTitle>운동기구 추가</MobileTitle>
        <AddMobileCategoryButton
          title="운동기구 추가"
          onSubmit={onSubmit}
          postResult={postSportingResult}
        />
      </Stack>
      <CreateSportingForm form={form} />
    </Stack>
  );
}
